<template>
   <PageFull header="Адм. пользователи" type="white" :fullwidth="true" :nopadding="true">
        <template v-slot:body>
            <div class="flex flex-column w-full">
                <Tabs :value="activeItem">
                    <div class="px-3">
                    <TabList>
                        <Tab :value="0">
                            <span class="font-medium text-sm xl:text-base lg:text-base">Пользователи</span>
                        </Tab>
                        <Tab :value="1">
                            <span class="font-medium text-sm xl:text-base lg:text-base">Переводы</span>
                        </Tab>
                    </TabList>
                    </div>
                    <TabPanels>
                        <TabPanel :value="0">
                            <UsersList />
                        </TabPanel>
                        <TabPanel :value="1">
                            <UsersScore />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </div>  
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import UsersList from '@/components/admin/UsersList.vue' 
import UsersScore from '@/components/admin/UsersScore.vue' 
import PageFull from '@/components/sides/PageFull.vue'

export default {
    data() {
        return {
            activeItem: 0,
            menuItems: [
                {label: 'Пользователи', icon: ''},
                {label: 'Переводы', icon: ''},
            ],
        }
    },
    components: {
        UsersList,
        UsersScore,
        PageFull
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    }
}
</script>